import { z } from 'zod'
import type { ActiveResearchCustomer } from '../../models/ActiveResearchCustomer'
import { createInstantSafe } from '~/shared/composables/useTemporal'

export const ActiveResearchCustomerDTO = z.object({
  should_show: z.boolean(),
  research_customer_id: z.number().nullable(),
  research_id: z.number().nullable(),
  completed: z.boolean(),
  answered_at: z.string().nullable()
})

export type ActiveResearchCustomerDTO = z.infer<typeof ActiveResearchCustomerDTO>

export const ActiveResearchCustomerResponseDTO = z.object({
  data: ActiveResearchCustomerDTO
})

export function mapDTOToActiveResearchCustomer (dto: ActiveResearchCustomerDTO): ActiveResearchCustomer {
  return {
    shouldShow: dto.should_show,
    researchCustomerId: dto.research_customer_id ?? undefined,
    researchId: dto.research_id ?? undefined,
    completed: dto.completed,
    answeredAt: createInstantSafe(dto.answered_at)
  }
}

export const ActiveResearchCustomerSubmitDTO = z.object({
  research_id: z.number(),
  research_customer_id: z.number().nullable().optional(),
  not_answered: z.literal(true)
})

export type ActiveResearchCustomerSubmitPayload = z.infer<typeof ActiveResearchCustomerSubmitDTO>

export function mapActiveResearchToSubmitPayload (input: {
  researchId: number
  researchCustomerId?: number
}): ActiveResearchCustomerSubmitPayload {
  return {
    research_id: input.researchId,
    research_customer_id: input.researchCustomerId ?? null,
    not_answered: true
  }
}
